import React from 'react';
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image';
import theme from 'mui/base/theme/index';
import Link from 'components/elements/Link';
import getProperImageData from 'utils/getProperImageData';

import { StyledImg, Wrapper } from './styles';

const ResponsiveImage = ({
  localMobileImage,
  mobileImage,
  localDesktopImage,
  desktopImage,
  tabletSameAsDesktop = false,
  link,
  gatsbyImageOptions = {},
}) => {
  const properMobileImage = getProperImageData(localMobileImage, mobileImage);
  const properDesktopImage = getProperImageData(localDesktopImage, desktopImage);

  const mobileBreakpoint = tabletSameAsDesktop ? theme.breakpoints.values.md : theme.breakpoints.values.lg;

  const gatsbyImageObject = !properMobileImage
    ? properDesktopImage?.gatsbyImageData
    : withArtDirection(getImage(properDesktopImage?.gatsbyImageData), [
        {
          media: `(max-width: ${mobileBreakpoint - 0.0625}em)`,
          image: getImage(properMobileImage.gatsbyImageData),
        },
      ]);

  const renderImages = () => (
    <Wrapper>
      {gatsbyImageObject ? (
        <GatsbyImage image={gatsbyImageObject} alt={properDesktopImage?.title || 'Image'} {...gatsbyImageOptions} />
      ) : (
        <StyledImg
          src={properDesktopImage?.file?.url || localDesktopImage?.file?.url}
          alt={properDesktopImage?.title || 'Image'}
          loading="lazy"
        />
      )}
    </Wrapper>
  );

  return link ? <Link url={link.url}>{renderImages()}</Link> : renderImages();
};

export default ResponsiveImage;
